import { createAction } from '@reduxjs/toolkit';

const setIsTesseractLoaded = createAction<boolean>('SERVICE_SET_IS_TESSERACT_LOADED');
const setIsWebsocketConnected = createAction<boolean>('SERVICE_SET_IS_WEBSOCKET_CONNECTED');
const setIsSmoEnvironmentImageClassifierLoaded = createAction<boolean>(
  'SERVICE_SET_IS_SMO_ENVIRONMENT_IMAGE_CLASSIFIER_LOADED'
);
const setIsSmoMoonTypeImageClassifierLoaded = createAction<boolean>(
  'SERVICE_SET_IS_SMO_MOON_TYPE_IMAGE_CLASSIFIER_LOADED'
);

export default {
  setIsTesseractLoaded,
  setIsWebsocketConnected,
  setIsSmoEnvironmentImageClassifierLoaded,
  setIsSmoMoonTypeImageClassifierLoaded
};
